export default __webpack_public_path__ + "static/media/hold-me.3def4189.jpeg";